module.exports = __webpack_public_path__ + "img/download.2cfc30e4.svg";